import React from 'react';
import { Colors, Images } from 'utils';
import { MinLoader } from '../loader';

export const SingleSearch = ({ searchTerm, setSearchTerm, placeholder, className, loading }) => {
    return (
        <div className={className ? className : 'search-setting-input'}>
            <div style={{ width: 18 }}>
                {loading ?
                    <MinLoader margin={'0'} width={'18px'} height={'18px'} color="#344054" position={'relative'} />
                    :
                    <img src={Images.searchIcon} alt="search" />
                }
            </div>
            <input
                type="search"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>
    );
};
